<div class="card-container">
  <div class="card primary-shadow"
       *ngFor="let item of cardData">
    <span class="border-content">
      <img width="72%" src="{{ item.icon }}">
    </span>
    <h6 style="text-align: center; padding: 0px 5px; font-weight: 600;">{{ item.title }}: {{ item.cant }}</h6>
  </div>
</div>
